import { config } from 'merchants/yellow';
import { stageRoutes } from 'system/Routing/stageRoutes.lazy';
import { App } from '../App';

 __webpack_public_path__ = `${(window as any).appConfig.cdn}/`;

(async () => {
  await App(config, stageRoutes);
})();
